import React, {useEffect, useState} from "react";
import Spinner from "../../../../spinner";
import {Button, Col, Table, Row, notification} from "antd";
import {tableHelper} from "../../../../../helpers";
import {useFetchNotification} from "../../../../../hooks/use-fetch-notification";
import NotificationMessage from "../../../../modals/notification-message";
import {userServices, epdAstralService} from "../../../../../services";
import {COMPANY_DIRECTOR_PERMISSION} from "../../../../../helpers/user_permission.helper";
import ModalLoginApiCompany from "../../../../modals/epd-astral/login-api-company";
import ModalAttorneyApiCompany from "../../../../modals/epd-astral/attorney-api-company";
import {Link, Route, Redirect} from "react-router-dom";
import i18n from "../../../../../i18n";

export default function EtrnLegalEntities() {
  const [loading, setLoading] = useState(false);
  const [isNeedUpdateEntities, setIsNeedUpdateEntities] = useState(false);
  const [stopListUpdate, setStopListUpdate] = useState(false);
  const [isModalRegisterApiCompanyShow, setIsModalRegisterApiCompanyShow] = useState(false);
  const [isModalAttorneyShow, setIsModalAttorneyShow] = useState(false);

  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [entitiesData, setEntitiesData] = useState(null);
  const [leId, setLeId] = useState(null);
  const [leName, setLeName] = useState(null);
  const [action, setAction] = useState(null);

  const [{notifications}] = useFetchNotification(true);

  const user = userServices.getUser();

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    float: 'right',
    borderColor: "#1CAA53"
  };

  useEffect(() => {
    if (loading === false && stopListUpdate !== true) {
      setLoading(true);
      setIsNeedUpdateEntities(true);
    }
  }, [isNeedUpdateEntities, stopListUpdate]);

  useEffect(() => {
    if (isNeedUpdateEntities) {
      epdAstralService
        .getCompanies()
        .then((response) => {
          let reindexedTableData = [];
          response.forEach((item) => {
            reindexedTableData.push({
              name: item.Name,
              orgForm: item.OrgForm,
              orgFormId: item.OrgFormId,
              id: item.Id,
              confirmation: item.VitalAgreed ? i18n.t('main.yes') : i18n.t('main.no'),
              permissions: item.Permissions,
              tax: (item.Tax ? item.Tax.fullTitle : ''),
              countryId: item.CountryId,
              edoAbonentId: (item.EtrnCompany ? item.EtrnCompany.abonentId : i18n.t('companyPage.epdAstral.notAbonent')),
              EtrnCompany: item.EtrnCompany,
            });
          });

          setEntitiesData(reindexedTableData);
          setIsNeedUpdateEntities(false);
          setLoading(false);
        })
        .catch((errorMsg) => {
          setIsNeedUpdateEntities(false);
          setErrorMsg(errorMsg);
          setLoading(false);
        });
    }
  }, [isNeedUpdateEntities]);


  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  const columns = [
    {
      title: i18n.t('companyPage.epdAstral.table.name.title'),
      dataIndex: "name",
      width: "25%",
      ...tableHelper.getColumnSearchProps("name", searchText, setSearchText),
    },
    {
      title: i18n.t('companyPage.epdAstral.table.orgForm.title'),
      dataIndex: "orgForm",
      width: "10%",
    },
    {
      title: i18n.t('companyPage.epdAstral.table.edoAbonentId.title'),
      dataIndex: "edoAbonentId",
      width: "35%",
    },
    {
      title: i18n.t('companyPage.epdAstral.table.attorney.title'),
      key: "attorney",
      width: "10%",
      render: (data) => {
        if(data.EtrnCompany && !data.EtrnCompany.locked && data.EtrnCompany.abonentId) {
          return (
            <React.Fragment>
              <Button
                type="primary"
                icon="edit"
                key={`${user}-plus`}
                onClick={() => {
                  setLeId(data.id);
                  setLeName(data.name);
                  setIsModalAttorneyShow(true);}
                }
              >
              </Button>
            </React.Fragment>
          );
        }
      },
    },
    {
      title: i18n.t('companyPage.epdAstral.table.actions.title'),
      key: "actions",
      width: "30%",
      render: (data) => {
        if (!data.EtrnCompany || (!data.EtrnCompany.locked && !data.EtrnCompany.abonentId)) {
          return (
            <React.Fragment>
              <Button
                type="primary"
                icon="plus"
                style={{width: '100%'}}
                key={`${user}-plus`}
                onClick={() => {
                  setLeId(data.id);
                  setLeName(data.name);
                  setAction('register');
                  setIsModalRegisterApiCompanyShow(true);}
                }
              >
                {i18n.t('companyPage.epdAstral.buttons.register')}
              </Button>
            </React.Fragment>
          );
        } else if(data.EtrnCompany && !data.EtrnCompany.locked && data.EtrnCompany.abonentId) {
          return (
            <React.Fragment>
              <Button
                type="primary"
                icon="plus"
                style={{width: '100%'}}
                key={`${user}-plus`}
                onClick={() => {
                  setLeId(data.id);
                  setLeName(data.name);
                  setAction('edit');
                  setIsModalRegisterApiCompanyShow(true);}
                }
              >
                {i18n.t('companyPage.epdAstral.buttons.edit')}
              </Button>
            </React.Fragment>
          );
        }
      },
    },
  ];


  if (!user.isAccessTo(COMPANY_DIRECTOR_PERMISSION)) {
    return <Redirect to="/company/car-park"/>;
  }

  return (
    <React.Fragment>
      <ModalLoginApiCompany onCloseModal={setIsModalRegisterApiCompanyShow} type={action} userId={user.id}
                      isShow={isModalRegisterApiCompanyShow} setIsNeedUpdate={setIsNeedUpdateEntities}
                      legalEntityId={leId} legalEntityName={leName}
                    />
      <ModalAttorneyApiCompany onCloseModal={setIsModalAttorneyShow} userId={user.id}
        isShow={isModalAttorneyShow} setIsNeedUpdate={setIsNeedUpdateEntities}
        legalEntityId={leId} legalEntityName={leName}
      />
      <NotificationMessage
        notifications={notifications}
        setStopListUpdate={setStopListUpdate}
        loading={false}
      />

      <Row>
        <Col
          className={"content-header"}
          style={{marginBottom: "0px"}}
          span={12}
        >
          {i18n.t('companyPage.epdAstral.title')}
        </Col>
      </Row>

      <Col span={24}>
        <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
          <Table
            style={{minWidth: "700px"}}
            columns={columns}
            dataSource={entitiesData}
            locale={{emptyText: i18n.t('main.empty')}}
            rowKey="id"
            size="small"
            pagination={{
              pageSize: 50,
            }}
            className="car-park"
            rowClassName={(record, index) => "car-park-row"}
          />
        </Spinner>
      </Col>
    </React.Fragment>
  );
}
